import {
  OrganizationPageCustomizationApi,
  ThanksGivingMessageApi,
  AdminApi,
  PatchedThanksGivingMessageReadRequest,
  PatchedThanksGivingAdminPatchRequest,
  TaskProgressApi,
  ThanksGivingApi,
  GrantCriteriaApi,
  MoveGrantCriteriaApi,
  PatchedGrantCriteriaMoveByOneRequest,
  GrantCriteriaRequest,
  PatchedGrantCriteriaPatchRequest,
  OrganizationAdminSettingsApi,
  GrantPointsApi,
  GrantPointCreateRequest,
  WhatsNewAdminApi,
  ListAvailableMonthsApi,
  GroupUsersInfoApi,
  UserAdminGroupDashboardSummaryApi,
  AdminDashboardGroupUsersInfoApi,
  UserGroupPointStatusApi,
  UserGroupGrantCriteriaRankingApi,
  UserGroupDashboardRankingApi,
  UserAdminDashboardSummaryApi,
  AdminUserPointStatusApi,
  AdminUserDashboardRankingApi,
  AdminUserGrantCriteriaRankingApi,
  ProductApplicationDataApi,
  ExpiringPointsDataApi,
  PointUsageApi,
  UserPointDataApi,
  UserDataApi,
  GroupDataApi,
  GrantCriteriaCsvUploadApi,
  ThanksOnlyPointsCsvUploadApi,
  GrantOnlyPointsApi,
  ThanksPointsApproveRejectApi,
  GrantPointsDeletionApi,
  UploadS3UrlApi,
  GroupPointDataApi,
  FailCsvUploadReportsApi,
  TaxDifferenceApi
} from "../../../gen/ricapi/api";

import {
  OrganizationApi,
  Organization,
  TokenApi,
  RicAuthTokenObtainResponse,
  CustomUserApi,
  CustomUser,
  TokenRefreshRequest,
  GroupApi,
  UserGroupRoleApi
} from "../../../gen/authapi/api";
import { AxiosResponse } from "axios";
import LocalStorage from "@/general/utils/storage";

export async function getAccessTokenByRefreshToken(
  refreshToken: TokenRefreshRequest
): Promise<RicAuthTokenObtainResponse> {
  const tokenApi = new TokenApi();
  const response = await (await tokenApi.tokenRefreshCreate(refreshToken)).data;
  return response;
}

export async function login(
  username: string,
  password: string
): Promise<RicAuthTokenObtainResponse> {
  const tokenApi = new TokenApi();
  const response = await (await tokenApi.tokenCreate({ username, password }))
    .data;

  LocalStorage.setItem("AccessToken", response.access);
  LocalStorage.setItem("RefreshToken", response.refresh);
  return response as RicAuthTokenObtainResponse;
}

export async function getOrganizationCustomizationData(
  id: number,
  search?: string,
  options?: any
) {
  const OrganizationPageCustomizationData = new OrganizationPageCustomizationApi();
  const Token = LocalStorage.getItem("AccessToken");
  const response = await (
    await OrganizationPageCustomizationData.organizationPageCustomizationRetrieve(
      id,
      search,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}

export async function postOrganizationCustomizationData(
  organization: number,
  pageTitle: string,
  pageColor: string,
  pointName: string,
  defaultThanksMessage: string,
  pageLogo: string,
  favicon: string,
  pointLogo: string,
  options?: any
) {
  const OrganizationPageCustomizationCreator = new OrganizationPageCustomizationApi();
  const Token = LocalStorage.getItem("AccessToken");
  const response = await (
    await OrganizationPageCustomizationCreator.organizationPageCustomizationCreate(
      organization,
      pageTitle,
      pageColor,
      pointName,
      defaultThanksMessage,
      undefined,
      undefined,
      undefined,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}

export async function getWhatsNewAdminList(
  filterMonth: string | undefined = undefined,
  filterYear: string | undefined = undefined,
  endDate: any,
  page: any,
  pageSize: number,
  search: any = "",
  startDate: any
) {
  const whatsNewAdminApi = new WhatsNewAdminApi();
  const Token = LocalStorage.getItem("AccessToken");
  const WhatsNewListResponse = await (
    await whatsNewAdminApi.whatsNewAdminList(
      filterMonth,
      filterYear,
      endDate,
      page,
      pageSize,
      search,
      startDate,
      { headers: { Authorization: "Bearer " + Token } }
    )
  ).data;
  return WhatsNewListResponse;
}

export async function whatsNewAdminDestroy(
  id: number,
  month: string | undefined = undefined,
  year: string | undefined = undefined,
  endDate: string | undefined = undefined,
  search: any = "",
  startDate: string | undefined = undefined
) {
  const whatsNewAdminApi = new WhatsNewAdminApi();
  const Token = LocalStorage.getItem("AccessToken");
  const response = await (
    await whatsNewAdminApi.whatsNewAdminDestroy(
      id,
      month,
      year,
      endDate,
      search,
      startDate,
      { headers: { Authorization: "Bearer " + Token } }
    )
  ).data;
  return response;
}

export async function whatsNewAdminCreate(createdData: any) {
  const whatsNewAdminApi = new WhatsNewAdminApi();
  const Token = LocalStorage.getItem("AccessToken");
  const response = await (
    await whatsNewAdminApi.whatsNewAdminCreate(createdData, {
      headers: { Authorization: "Bearer " + Token }
    })
  ).data;
  return response;
}

export async function whatsNewAdminPartialUpdate(id: number, editData: any) {
  const whatsNewAdminApi = new WhatsNewAdminApi();
  const Token = LocalStorage.getItem("AccessToken");
  const response = await (
    await whatsNewAdminApi.whatsNewAdminPartialUpdate(
      id,
      "",
      "",
      "",
      "",
      "",
      editData,
      { headers: { Authorization: "Bearer " + Token } }
    )
  ).data;
  return response;
}

export async function listAvailableMonthsList() {
  const listAvailableMonthsApi = new ListAvailableMonthsApi();
  const Token = LocalStorage.getItem("AccessToken");
  const response = await (
    await listAvailableMonthsApi.listAvailableMonthsList(
      undefined,
      undefined,
      undefined,
      { headers: { Authorization: "Bearer " + Token } }
    )
  ).data;
  return response;
}

export async function whatsNewAdminRetrieve(id: number) {
  const whatsNewAdminApi = new WhatsNewAdminApi();
  const Token = LocalStorage.getItem("AccessToken");
  const response = await (
    await whatsNewAdminApi.whatsNewAdminRetrieve(id, "", "", "", "", "", {
      headers: { Authorization: "Bearer " + Token }
    })
  ).data;
  return response;
}

export async function partialUpdateOrganizationCustomizationData(
  organization: number,
  search?: string,
  pageTitle?: string,
  pageLogo?: string,
  favicon?: string,
  pageColor?: string,
  pointName?: string,
  pointLogo?: string | undefined,
  defaultThanksMessage?: string,
  options?: any
) {
  if (pageLogo == "") {
    pageLogo = undefined;
  }
  if (favicon == "") {
    favicon = undefined;
  }
  if (pageColor == "") {
    pageColor = undefined;
  }
  if (pointName == "") {
    pointName = undefined;
  }
  if (pointLogo == "") {
    pointLogo = undefined;
  }
  if (defaultThanksMessage == "") {
    defaultThanksMessage = undefined;
  }
  const OrganizationPageCustomizationUpdate = new OrganizationPageCustomizationApi();
  const Token = LocalStorage.getItem("AccessToken");
  const response = await (
    await OrganizationPageCustomizationUpdate.organizationPageCustomizationPartialUpdate(
      organization,
      search,
      pageTitle,
      undefined,
      undefined,
      pageColor,
      pointName,
      undefined,
      defaultThanksMessage,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}

export async function getThanksPointAdminList(
  createdMonth?: string,
  createdYear?: string,
  expired?: string,
  fromUser?: string,
  page?: number,
  pageSize?: number,
  pointsRange?: string,
  search?: string,
  status?: "approved" | "pending" | "rejected",
  toUser?: string
) {
  const thanksGivingMessageApi = new AdminApi();

  const Token = LocalStorage.getItem("AccessToken");

  const ThanksPointAdminResponse = await (
    await thanksGivingMessageApi.adminThanksGivingList(
      createdMonth,
      createdYear,
      expired,
      fromUser,
      LocalStorage.getItem("USER_GROUP_ID")
        ? (LocalStorage.getItem("USER_GROUP_ID") as string)
        : undefined,
      page,
      pageSize,
      pointsRange,
      search,
      status,
      toUser,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return ThanksPointAdminResponse;
}

export async function getThanksPointAdminDetails(
  id: number,
  createdMonth?: string,
  createdYear?: string,
  expired?: string,
  fromUser?: string,
  pointsRange?: string,
  search?: string,
  status?: "approved" | "pending" | "rejected",
  toUser?: string
) {
  const thanksGivingMessageApi = new AdminApi();

  const Token = LocalStorage.getItem("AccessToken");

  const ThanksPointAdminDetailResponse = await (
    await thanksGivingMessageApi.adminThanksGivingRetrieve(
      id,
      createdMonth,
      createdYear,
      expired,
      fromUser,
      undefined,
      pointsRange,
      search,
      status,
      toUser,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return ThanksPointAdminDetailResponse;
}

export async function patchThanksPointAdminDetails(
  id: number,
  createdMonth?: string,
  createdYear?: string,
  expired?: string,
  fromUser?: string,
  pointsRange?: string,
  search?: string,
  status?: "approved" | "pending" | "rejected",
  toUser?: string,
  patchedThanksGivingAdminPatchRequest?: PatchedThanksGivingAdminPatchRequest
) {
  const thanksGivingMessageApi = new AdminApi();

  const Token = LocalStorage.getItem("AccessToken");

  const ThanksPointAdminDetailUpdateResponse = await (
    await thanksGivingMessageApi.adminThanksGivingPartialUpdate(
      id,
      createdMonth,
      createdYear,
      expired,
      fromUser,
      undefined,
      pointsRange,
      search,
      status,
      toUser,
      patchedThanksGivingAdminPatchRequest,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return ThanksPointAdminDetailUpdateResponse;
}

export async function adminThanksGivingExportAPI(
  groupId: number,
  createdMonth: string | undefined,
  createdYear: string | undefined,
  endDate: string | undefined,
  expired: string | undefined,
  fromUser: string | undefined,
  pointsRange: string | undefined,
  startDate: string | undefined,
  status: string | undefined,
  toUser: string | undefined,
  userDesignation: string | undefined,
  userSearch: string | undefined,
  groupDesignation: string | undefined,
  groupSearch: string | undefined
) {
  const adminThanksGivingExportApi = new AdminApi();

  const Token = LocalStorage.getItem("AccessToken");

  const AdminThanksGivingExportAPIResponse = await (
    await adminThanksGivingExportApi.adminThanksGivingExportReportRetrieve(
      groupId,
      createdMonth,
      createdYear,
      endDate,
      expired,
      fromUser,
      groupDesignation,
      groupSearch,
      pointsRange,
      startDate,
      status,
      toUser,
      userDesignation,
      userSearch,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return AdminThanksGivingExportAPIResponse;
}

export async function taskProgressRetrieveApi(taskId: string) {
  const taskProgressApi = new TaskProgressApi();

  const Token = LocalStorage.getItem("AccessToken");

  const TaskProgressApiResponse = await (
    await taskProgressApi.taskProgressRetrieve(taskId, {
      headers: { Authorization: "Bearer " + Token }
    })
  ).data;
  return TaskProgressApiResponse;
}

export async function bulkUpdateThanksPointAdminAPI(
  patchedBulkUpdateThanksGivingRequest: any
) {
  const bulkUpdatePoints = new AdminApi();

  const Token = LocalStorage.getItem("AccessToken");

  const TaskProgressApiResponse = await (
    await bulkUpdatePoints.adminBulkUpdateThanksGivingPartialUpdate(
      patchedBulkUpdateThanksGivingRequest,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return TaskProgressApiResponse;
}

export async function avilableMonthListThanksPoint(
  expired?: string,
  page?: number,
  pageSize?: number,
  search?: string,
  status?: string
) {
  const availableListMonthApi = new ThanksGivingApi();

  const Token = LocalStorage.getItem("AccessToken");

  const TaskProgressApiResponse = await (
    await availableListMonthApi.thanksGivingListAvailableMonthsList(
      expired,
      page,
      pageSize,
      search,
      status,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return TaskProgressApiResponse;
}

/* Groups */

export async function getGroupList(
  hierarchy?: string,
  ids?: string,
  ordering?: string,
  organization?: string,
  page?: number,
  pageSize?: number,
  parentGroup?: string,
  search?: string,
  simplify?: string
) {
  const groupApi = new GroupApi();
  const Token = LocalStorage.getItem("AccessToken");

  const groupListResponse = await groupApi.groupList(
    undefined,
    hierarchy,
    undefined,
    ids,
    undefined,
    ordering,
    organization,
    page,
    pageSize,
    parentGroup,
    search,
    undefined
  );
  return groupListResponse.data;
}

export async function getGroupApi(id: number) {
  const groupApi = new GroupApi();
  const Token = LocalStorage.getItem("AccessToken");

  const groupResponse = await groupApi.groupRetrieve(id, {
    headers: { Authorization: " Bearer " + Token }
  });
  return groupResponse.data;
}

/* Grant Criteria */

export async function getGrantCriteriaList(
  grantType: any,
  ordering: string,
  page: number,
  pageSize = 20,
  search: string
) {
  const grantCriteriaApi = new GrantCriteriaApi();
  const Token = LocalStorage.getItem("AccessToken");

  const GrantCriteriaListResponse = await grantCriteriaApi.grantCriteriaList(
    grantType,
    LocalStorage.getItem("USER_GROUP_ID")
      ? (LocalStorage.getItem("USER_GROUP_ID") as string)
      : undefined,
    ordering,
    page,
    pageSize,
    search,
    { headers: { Authorization: " Bearer " + Token } }
  );
  return GrantCriteriaListResponse.data;
}

export async function saveGrantCriteriaSortOrder(
  data: PatchedGrantCriteriaMoveByOneRequest
) {
  const Token = LocalStorage.getItem("AccessToken");

  const moveGrantCriteriaApi = new MoveGrantCriteriaApi();
  const moveGrantCriteriaResponse = await moveGrantCriteriaApi.moveGrantCriteriaPartialUpdate(
    data,
    { headers: { Authorization: " Bearer " + Token } }
  );

  return moveGrantCriteriaResponse.data;
}

export async function getGrantCriteriaDetails(
  id: number,
  grantType: any,
  ordering: string,
  search: string
) {
  const grantCriteriaApi = new GrantCriteriaApi();
  const Token = LocalStorage.getItem("AccessToken");

  const GrantCriteriaDetailsResponse = await grantCriteriaApi.grantCriteriaRetrieve(
    id,
    grantType,
    LocalStorage.getItem("USER_GROUP_ID")
      ? (LocalStorage.getItem("USER_GROUP_ID") as string)
      : undefined,
    ordering,
    search,
    { headers: { Authorization: " Bearer " + Token } }
  );
  return GrantCriteriaDetailsResponse?.data;
}

export async function createGrantCriteria(
  grantCriteriaRequest: GrantCriteriaRequest
) {
  const grantCriteriaApi = new GrantCriteriaApi();
  const Token = LocalStorage.getItem("AccessToken");

  const grantCriteriaCreateResponse = await grantCriteriaApi.grantCriteriaCreate(
    grantCriteriaRequest,
    { headers: { Authorization: " Bearer " + Token } }
  );
  return grantCriteriaCreateResponse.data;
}

export async function updateGrantCriteriaDetails(
  id: number,
  grantType: any,
  ordering?: string,
  search?: string,
  request?: PatchedGrantCriteriaPatchRequest
) {
  const grantCriteriaApi = new GrantCriteriaApi();
  const Token = LocalStorage.getItem("AccessToken");

  const grantCriteriaDeleteResponse = await grantCriteriaApi.grantCriteriaPartialUpdate(
    id,
    grantType,
    LocalStorage.getItem("USER_GROUP_ID")
      ? (LocalStorage.getItem("USER_GROUP_ID") as string)
      : undefined,
    ordering,
    search,
    request,
    { headers: { Authorization: " Bearer " + Token } }
  );
  return grantCriteriaDeleteResponse.data;
}

export async function updateGrantCriteriaGroups(
  id: number,
  grantType: any,
  ordering?: string,
  search?: string,
  request?: PatchedGrantCriteriaPatchRequest
) {
  const grantCriteriaApi = new GrantCriteriaApi();
  const Token = LocalStorage.getItem("AccessToken");

  const grantCriteriaDeleteResponse = await grantCriteriaApi.grantCriteriaPartialUpdate(
    id,
    grantType,
    LocalStorage.getItem("USER_GROUP_ID")
      ? (LocalStorage.getItem("USER_GROUP_ID") as string)
      : undefined,
    ordering,
    search,
    request,
    { headers: { Authorization: " Bearer " + Token } }
  );
  return grantCriteriaDeleteResponse.data;
}

export async function deleteGrantCriteria(
  id: number,
  grantType: any,
  ordering: string,
  search: string
) {
  const grantCriteriaApi = new GrantCriteriaApi();
  const Token = LocalStorage.getItem("AccessToken");

  const grantCriteriaDeleteResponse = await grantCriteriaApi.grantCriteriaDestroy(
    id,
    grantType,
    LocalStorage.getItem("USER_GROUP_ID")
      ? (LocalStorage.getItem("USER_GROUP_ID") as string)
      : undefined,
    ordering,
    search,
    { headers: { Authorization: " Bearer " + Token } }
  );
  return grantCriteriaDeleteResponse.data;
}

/* Grant Points */

export async function getGrantPointPeriods() {
  const grantPointsApi = new GrantPointsApi();
  const Token = LocalStorage.getItem("AccessToken");

  const grantPointPeriodsResponse = await grantPointsApi.grantPointsListAvailableMonthsList(
    LocalStorage.getItem("USER_GROUP_ID")
      ? parseInt(LocalStorage.getItem("USER_GROUP_ID") as string, 10)
      : undefined,
    1,
    100,
    "",
    { headers: { Authorization: " Bearer " + Token } }
  );
  return grantPointPeriodsResponse.data;
}

export async function getGrantPointHistoryList(
  created_month: string,
  created_year: string,
  from_user: string,
  include_deleted: string,
  ordering: string,
  page: number,
  pageSize = 20,
  search: string,
  to_user: string
) {
  const grantPointsApi = new GrantPointsApi();
  const Token = LocalStorage.getItem("AccessToken");

  const grantPointHistoryListResponse = await grantPointsApi.grantPointsList(
    created_month,
    created_year,
    from_user,
    LocalStorage.getItem("USER_GROUP_ID")
      ? (LocalStorage.getItem("USER_GROUP_ID") as string)
      : undefined,
    include_deleted,
    ordering,
    page,
    pageSize,
    search,
    to_user,
    { headers: { Authorization: " Bearer " + Token } }
  );
  return grantPointHistoryListResponse.data;
}

export async function getGrantPointHistoryDetails(
  id: number,
  created_month: string,
  created_year: string,
  from_user: string,
  include_deleted: string,
  ordering: string,
  search: string,
  to_user: string
) {
  const grantPointsApi = new GrantPointsApi();
  const Token = LocalStorage.getItem("AccessToken");

  const grantPointHistoryDetailsResponse = await grantPointsApi.grantPointsRetrieve(
    id,
    created_month,
    created_year,
    from_user,
    LocalStorage.getItem("USER_GROUP_ID")
      ? (LocalStorage.getItem("USER_GROUP_ID") as string)
      : undefined,
    include_deleted,
    ordering,
    search,
    to_user,
    { headers: { Authorization: " Bearer " + Token } }
  );
  return grantPointHistoryDetailsResponse.data;
}

export async function getGrantPointGroups(
  grantCriteria: number | undefined,
  groupId: number | undefined,
  groupOrdering: string,
  page: number,
  pageSize: number,
  search: string,
  userOrdering: string
) {
  const groupUsersInfoApi = new GroupUsersInfoApi();
  const Token = LocalStorage.getItem("AccessToken");

  const grantPointGroupResponse = await groupUsersInfoApi.groupUsersInfoList(
    grantCriteria,
    groupId,
    groupOrdering,
    page,
    pageSize,
    search,
    userOrdering,
    { headers: { Authorization: " Bearer " + Token } }
  );
  return grantPointGroupResponse.data;
}

export async function createGrantPoint(
  grantPointCreate: GrantPointCreateRequest
) {
  const grantPointsApi = new GrantPointsApi();
  const Token = LocalStorage.getItem("AccessToken");

  const grantPointCreateResponse = await grantPointsApi.grantPointsCreate(
    grantPointCreate,
    { headers: { Authorization: " Bearer " + Token } }
  );
  return grantPointCreateResponse.data;
}

export async function deleteGrantPoint(
  id: number,
  created_month: string,
  created_year: string,
  from_user: string,
  include_deleted: string,
  ordering: string,
  search: string,
  to_user: string
) {
  const grantPointsApi = new GrantPointsApi();
  const Token = LocalStorage.getItem("AccessToken");

  const grantPointDeleteResponse = await grantPointsApi.grantPointsDestroy(
    id,
    created_month,
    created_year,
    from_user,
    LocalStorage.getItem("USER_GROUP_ID")
      ? (LocalStorage.getItem("USER_GROUP_ID") as string)
      : undefined,
    include_deleted,
    ordering,
    search,
    to_user,
    { headers: { Authorization: " Bearer " + Token } }
  );
  return grantPointDeleteResponse.data;
}

/* CustomUserApi */

export async function getUserRoles() {
  const customUserApi = new CustomUserApi();
  const Token = LocalStorage.getItem("AccessToken");

  const userDetails = JSON.parse(LocalStorage.getItem("userDetails") as string);
  const userId = userDetails?.id;

  const groupId = LocalStorage.getItem("USER_GROUP_ID")
    ? parseInt(LocalStorage.getItem("USER_GROUP_ID") as string, 10)
    : 0;

  const userRolesResponse = await customUserApi.customUserGetUserGroupRoleRetrieve(
    groupId,
    userId,
    { headers: { Authorization: " Bearer " + Token } }
  );

  return userRolesResponse.data;
}

export async function getCustomerUserList(
  excludeCurrentUser?: string,
  groupIds?: string,
  hiraganaName?: string,
  katakanaName?: string,
  nestedUsers?: string,
  ordering?: string,
  organization?: string,
  page?: number,
  pageSize?: number,
  roleType?: string,
  search?: string,
  searchPattern?: "user_info" | "user_and_group_info",
  username?: string,
  usingEmployeeId?: string
) {
  const customUserApi = new CustomUserApi();
  const Token = LocalStorage.getItem("AccessToken");

  const customerUserListResponse = await customUserApi.customUserList(
    excludeCurrentUser,
    groupIds,
    hiraganaName,
    undefined, //isDeleted
    katakanaName,
    nestedUsers,
    ordering,
    organization,
    page,
    pageSize,
    roleType,
    search,
    searchPattern,
    username,
    usingEmployeeId,
    { headers: { Authorization: " Bearer " + Token } }
  );

  return customerUserListResponse.data;
}

export async function grantPointsExportApi(
  groupId: number,
  destinationGroupSearch: string | undefined,
  endDate: string | undefined,
  startDate: string | undefined,
  toUser: string | undefined,
  fromUser: string | undefined,
  grantCriteriaSearch: string | undefined,
  grantType?: string,
  sourceGroupSearch?: string
) {
  const adminThanksGivingExportApi = new GrantPointsApi();

  const Token = LocalStorage.getItem("AccessToken");

  const AdminThanksGivingExportAPIResponse = await (
    await adminThanksGivingExportApi.grantPointsExportReportRetrieve(
      groupId,
      destinationGroupSearch,
      endDate,
      fromUser,
      grantCriteriaSearch,
      grantType,
      sourceGroupSearch,
      startDate,
      toUser,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return AdminThanksGivingExportAPIResponse;
}

export async function pointsUsageExportApi(
  groupId: number,
  endDate?: string | undefined,
  startDate?: string | undefined,
  userSearch?: string | undefined,
  groupSearch?: string | undefined
) {
  const pointUsageApi = new PointUsageApi();

  const Token = LocalStorage.getItem("AccessToken");

  const response = await (
    await pointUsageApi.pointUsageExportReportRetrieve(
      groupId,
      endDate,
      groupSearch,
      startDate,
      userSearch,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}

export async function expiringPointsExportApi(
  groupId: number,
  endDate: string | undefined,
  startDate: string | undefined,
  userSearch: string | undefined,
  groupSearch: string | undefined,
  pointType: string | undefined,
  usersNotCoveredByTheSystem: string | undefined
) {
  const expiringPointsDataApi = new ExpiringPointsDataApi();

  const Token = LocalStorage.getItem("AccessToken");

  const response = await (
    await expiringPointsDataApi.expiringPointsDataExportReportRetrieve(
      groupId,
      endDate,
      groupSearch,
      pointType,
      startDate,
      userSearch,
      usersNotCoveredByTheSystem,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}

export async function grantCriteriaExportApi(
  groupId: number,
  endDate: string | undefined,
  startDate: string | undefined,
  grantStandardSearch: string | undefined,
  kind: string | undefined
) {
  const grantCriteriaApi = new GrantCriteriaApi();

  const Token = LocalStorage.getItem("AccessToken");

  const response = await (
    await grantCriteriaApi.grantCriteriaExportReportRetrieve(
      groupId,
      endDate,
      grantStandardSearch,
      kind,
      startDate,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}

export async function productApplicationDataExportApi(
  groupId: number,
  endDate: string | undefined,
  startDate: string | undefined,
  userSearch: string | undefined,
  groupSearch: string | undefined
) {
  const productApplicationDataApi = new ProductApplicationDataApi();

  const Token = LocalStorage.getItem("AccessToken");

  const response = await (
    await productApplicationDataApi.productApplicationDataExportReportRetrieve(
      groupId,
      endDate,
      groupSearch,
      startDate,
      userSearch,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}

export async function userPointDataExportApi(
  groupId: number,
  endDate: string | undefined,
  startDate: string | undefined,
  userSearch: string | undefined,
  groupSearch: string | undefined,
  usersNotCoveredByTheSystem: string | undefined
) {
  const userPointDataApi = new UserPointDataApi();

  const Token = LocalStorage.getItem("AccessToken");

  const response = await (
    await userPointDataApi.userPointDataExportReportRetrieve(
      groupId,
      endDate,
      groupSearch,
      startDate,
      userSearch,
      usersNotCoveredByTheSystem,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}

export async function userDataExportApi(
  groupId: number,
  endDate?: string,
  groupSearch?: string,
  isEmailRegistred?: string,
  search?: string,
  startDate?: string,
  userSearch?: string | undefined,
  usersNotCoveredByTheSystem?: string,
  withLoginHistory?: string
) {
  const userDataApi = new UserDataApi();

  const Token = LocalStorage.getItem("AccessToken");

  const response = await (
    await userDataApi.userDataRetrieve(
      groupId,
      endDate,
      groupSearch,
      isEmailRegistred,
      search,
      startDate,
      userSearch,
      usersNotCoveredByTheSystem,
      withLoginHistory,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}

export async function groupDataExportApi(
  groupId: number,
  endDate?: string | undefined,
  search?: string,
  startDate?: string | undefined
) {
  const groupDataApi = new GroupDataApi();

  const Token = LocalStorage.getItem("AccessToken");

  const response = await (
    await groupDataApi.groupDataRetrieve(groupId, endDate, search, startDate, {
      headers: { Authorization: "Bearer " + Token }
    })
  ).data;
  return response;
}

/* Dashboard API's */

export async function getAdminDashboardGroupUserData(
  groupId: number,
  search: any
) {
  const userAdminGroupDashboardSummaryApi = new UserAdminGroupDashboardSummaryApi();
  const Token = LocalStorage.getItem("AccessToken");
  const response = await (
    await userAdminGroupDashboardSummaryApi.userAdminGroupDashboardSummaryRetrieve(
      groupId,
      search,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}

export async function getAdminDashboardGroups(
  groupId?: number,
  ordering?: string,
  page?: number,
  pageSize?: number,
  parentGroup?: string,
  search?: string
) {
  const adminDashboardGroupUsersInfoApi = new AdminDashboardGroupUsersInfoApi();
  const Token = LocalStorage.getItem("AccessToken");
  const response = await (
    await adminDashboardGroupUsersInfoApi.adminDashboardGroupUsersInfoRetrieve(
      groupId,
      ordering,
      page,
      pageSize,
      parentGroup,
      search,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}

export async function getUserGroupPointStatus(
  groupId: number,
  startDate: string,
  search: string
) {
  const userGroupPointStatusApi = new UserGroupPointStatusApi();
  const Token = LocalStorage.getItem("AccessToken");
  const response = await (
    await userGroupPointStatusApi.userGroupPointStatusRetrieve(
      groupId,
      startDate,
      search,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}

export async function getUserGroupGrantCriteriaRanking(
  groupId: number,
  startDate: string,
  search: string
) {
  const userGroupGrantCriteriaRankingApi = new UserGroupGrantCriteriaRankingApi();
  const Token = LocalStorage.getItem("AccessToken");
  const response = await (
    await userGroupGrantCriteriaRankingApi.userGroupGrantCriteriaRankingRetrieve(
      groupId,
      startDate,
      search,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}

export async function getUserGroupDashboardRanking(
  groupId: number,
  startDate: string,
  search: string
) {
  const userGroupDashboardRankingApi = new UserGroupDashboardRankingApi();
  const Token = LocalStorage.getItem("AccessToken");
  const response = await (
    await userGroupDashboardRankingApi.userGroupDashboardRankingRetrieve(
      groupId,
      startDate,
      search,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}

export async function getAdminDashboardUserData(
  groupId: number,
  userId: number,
  search: string
) {
  const userAdminDashboardSummaryApi = new UserAdminDashboardSummaryApi();
  const Token = LocalStorage.getItem("AccessToken");
  const response = await (
    await userAdminDashboardSummaryApi.userAdminDashboardSummaryRetrieve(
      groupId,
      userId,
      search,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}

export async function getUserPointStatus(
  endDate: string,
  groupId: number,
  startDate: string,
  userId: number,
  search: string
) {
  const adminUserPointStatusApi = new AdminUserPointStatusApi();
  const Token = LocalStorage.getItem("AccessToken");
  const response = await (
    await adminUserPointStatusApi.adminUserPointStatusRetrieve(
      endDate,
      groupId,
      startDate,
      userId,
      search,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}

export async function getUserDashboardRanking(
  endDate: string,
  groupId: number,
  startDate: string,
  userId: number,
  search: string
) {
  const adminUserDashboardRankingApi = new AdminUserDashboardRankingApi();
  const Token = LocalStorage.getItem("AccessToken");
  const response = await (
    await adminUserDashboardRankingApi.adminUserDashboardRankingRetrieve(
      endDate,
      groupId,
      startDate,
      userId,
      search,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}

export async function getUserGrantCriteriaRanking(
  endDate: string,
  groupId: number,
  startDate: string,
  userId: number,
  search: string
) {
  const adminUserGrantCriteriaRankingApi = new AdminUserGrantCriteriaRankingApi();
  const Token = LocalStorage.getItem("AccessToken");
  const response = await (
    await adminUserGrantCriteriaRankingApi.adminUserGrantCriteriaRankingRetrieve(
      endDate,
      groupId,
      startDate,
      userId,
      search,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}

export async function getGrantCriteriaCsvUpload(id: number) {
  const grantCriteriaCsvUploadApi = new GrantCriteriaCsvUploadApi();

  const Token = LocalStorage.getItem("AccessToken");

  const response = await (
    await grantCriteriaCsvUploadApi.grantCriteriaCsvUploadRetrieve(
      id,
      undefined,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}

export async function postGrantCriteriaCsvUpload(
  groupId: number,
  fileUploaded: any
) {
  const grantCriteriaCsvUploadApi = new GrantCriteriaCsvUploadApi();

  const Token = LocalStorage.getItem("AccessToken");

  const response = await (
    await grantCriteriaCsvUploadApi.grantCriteriaCsvUploadCreate(
      groupId,
      fileUploaded,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;

  return response;
}

export async function getGrantCriteriaCsvLoadData(groupId: number, id: number) {
  const grantCriteriaCsvUploadApi = new GrantCriteriaCsvUploadApi();

  const Token = LocalStorage.getItem("AccessToken");

  const response = await (
    await grantCriteriaCsvUploadApi.grantCriteriaCsvUploadDatabaseOperationRetrieve(
      groupId,
      id,
      undefined,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}

export async function getGrantPointCsvUpload(id: number) {
  const grantPointsApi = new GrantPointsApi();

  const Token = LocalStorage.getItem("AccessToken");

  const response = await (
    await grantPointsApi.grantPointsCsvUploadRetrieve(id, undefined, {
      headers: { Authorization: "Bearer " + Token }
    })
  ).data;
  return response;
}

export async function postGrantPointCsvUpload(file: any) {
  const grantPointsApi = new GrantPointsApi();

  const Token = LocalStorage.getItem("AccessToken");

  const response = await (
    await grantPointsApi.grantPointsCsvUploadCreate(file, {
      headers: { Authorization: "Bearer " + Token }
    })
  ).data;
  return response;
}

export async function getGrantPointCsvLoadData(id: number) {
  const grantPointsApi = new GrantPointsApi();

  const Token = LocalStorage.getItem("AccessToken");

  const response = await (
    await grantPointsApi.grantPointsCsvUploadLoadDataRetrieve(id, undefined, {
      headers: { Authorization: "Bearer " + Token }
    })
  ).data;
  return response;
}

export async function getGrantingThanksOnlyCsvUpload(id: number) {
  const thanksOnlyPointsCsvUploadApi = new ThanksOnlyPointsCsvUploadApi();

  const Token = LocalStorage.getItem("AccessToken");

  const response = await (
    await thanksOnlyPointsCsvUploadApi.thanksOnlyPointsCsvUploadRetrieve(
      id,
      undefined,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}

export async function postGrantingThanksOnlyCsvUpload(file: any) {
  const thanksOnlyPointsCsvUploadApi = new ThanksOnlyPointsCsvUploadApi();

  const Token = LocalStorage.getItem("AccessToken");

  const response = await (
    await thanksOnlyPointsCsvUploadApi.thanksOnlyPointsCsvUploadCreate(file, {
      headers: { Authorization: "Bearer " + Token }
    })
  ).data;
  return response;
}

export async function getGrantingThanksOnlyCsvLoadData(id: number) {
  const thanksOnlyPointsCsvUploadApi = new ThanksOnlyPointsCsvUploadApi();

  const Token = LocalStorage.getItem("AccessToken");

  const response = await (
    await thanksOnlyPointsCsvUploadApi.thanksOnlyPointsCsvUploadDatabaseOperationRetrieve(
      id,
      undefined,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}

export async function getGrantingGrantOnlyCsvUpload(id: number) {
  const grantOnlyPointsApi = new GrantOnlyPointsApi();

  const Token = LocalStorage.getItem("AccessToken");

  const response = await (
    await grantOnlyPointsApi.grantOnlyPointsCsvUploadRetrieve(id, undefined, {
      headers: { Authorization: "Bearer " + Token }
    })
  ).data;
  return response;
}

export async function postGrantingGrantOnlyCsvUpload(file: any) {
  const grantOnlyPointsApi = new GrantOnlyPointsApi();

  const Token = LocalStorage.getItem("AccessToken");

  const response = await (
    await grantOnlyPointsApi.grantOnlyPointsCsvUploadCreate(file, {
      headers: { Authorization: "Bearer " + Token }
    })
  ).data;
  return response;
}

export async function getGrantingGrantOnlyCsvLoadData(id: number) {
  const grantOnlyPointsApi = new GrantOnlyPointsApi();

  const Token = LocalStorage.getItem("AccessToken");

  const response = await (
    await grantOnlyPointsApi.grantOnlyPointsCsvUploadLoadDataRetrieve(
      id,
      undefined,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}

export async function getThanksApprovalDisapprovalCsvUpload(id: number) {
  const thanksPointsApproveRejectApi = new ThanksPointsApproveRejectApi();

  const Token = LocalStorage.getItem("AccessToken");

  const response = await (
    await thanksPointsApproveRejectApi.thanksPointsApproveRejectRetrieve(
      id,
      undefined,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}

export async function postThanksApprovalDisapprovalCsvUpload(file: any) {
  const thanksPointsApproveRejectApi = new ThanksPointsApproveRejectApi();

  const Token = LocalStorage.getItem("AccessToken");

  const response = await (
    await thanksPointsApproveRejectApi.thanksPointsApproveRejectCreate(file, {
      headers: { Authorization: "Bearer " + Token }
    })
  ).data;
  return response;
}

export async function getThanksApprovalDisapprovalCsvLoadData(id: number) {
  const thanksPointsApproveRejectApi = new ThanksPointsApproveRejectApi();

  const Token = LocalStorage.getItem("AccessToken");

  const response = await (
    await thanksPointsApproveRejectApi.thanksPointsApproveRejectDatabaseOperationRetrieve(
      id,
      undefined,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}

export async function getGrantPointsDeletionCsvUpload(id: number) {
  const grantPointsDeletionApi = new GrantPointsDeletionApi();

  const Token = LocalStorage.getItem("AccessToken");

  const response = await (
    await grantPointsDeletionApi.grantPointsDeletionCsvUploadRetrieve(
      id,
      undefined,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}

export async function postGrantPointsDeletionCsvUpload(file: any) {
  const grantPointsDeletionApi = new GrantPointsDeletionApi();

  const Token = LocalStorage.getItem("AccessToken");

  const response = await (
    await grantPointsDeletionApi.grantPointsDeletionCsvUploadCreate(file, {
      headers: { Authorization: "Bearer " + Token }
    })
  ).data;
  return response;
}

export async function getGrantPointsDeletionCsvLoadData(id: number) {
  const grantPointsDeletionApi = new GrantPointsDeletionApi();

  const Token = LocalStorage.getItem("AccessToken");

  const response = await (
    await grantPointsDeletionApi.grantPointsDeletionCsvUploadLoadDataRetrieve(
      id,
      undefined,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}

// Upload S3 URL - CKEditor
export async function getUploadS3Url(file: string) {
  const Token = LocalStorage.getItem("AccessToken");

  const uploadS3UrlApi = new UploadS3UrlApi();

  const response = await uploadS3UrlApi.uploadS3UrlRetrieve(file, undefined, {
    headers: { Authorization: "Bearer " + Token }
  });
  return response?.data?.url;
}

export async function groupPointDataExportApi(
  groupId: number,
  endDate: string | undefined,
  startDate: string | undefined,
  search: string | undefined,
  groupSearch: string | undefined
) {
  const groupPointDataApi = new GroupPointDataApi();

  const Token = LocalStorage.getItem("AccessToken");

  const response = await (
    await groupPointDataApi.groupPointDataRetrieve(
      groupId,
      endDate,
      groupSearch,
      search,
      startDate,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}

/* User Group Roles */

export async function getAdminOnlyGroups() {
  const userGroupRoleApi = new UserGroupRoleApi();
  const Token = LocalStorage.getItem("AccessToken");
  const userDetails = JSON.parse(LocalStorage.getItem("userDetails") as string);

  const adminGroupsResponse = await userGroupRoleApi.userGroupRoleList(
    "true",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    userDetails?.id,
    { headers: { Authorization: "Bearer " + Token } }
  );
  return adminGroupsResponse?.data;
}

export async function getFailCsvUploadReports(
  page: number | undefined,
  pageSize: number | undefined
) {
  const failCsvUploadReportsApi = new FailCsvUploadReportsApi();
  const Token = LocalStorage.getItem("AccessToken");
  const userDetails = JSON.parse(LocalStorage.getItem("userDetails") as string);

  const adminGroupsResponse = await failCsvUploadReportsApi.failCsvUploadReportsList(
    undefined,
    page,
    pageSize,
    undefined,
    { headers: { Authorization: "Bearer " + Token } }
  );
  return adminGroupsResponse?.data;
}

export async function getTaxDifferenceCsvLoadData(
  groupId: number,
  month: string | undefined,
  year: string | undefined
) {
  const taxDifferenceApi = new TaxDifferenceApi();

  const Token = LocalStorage.getItem("AccessToken");

  const response = await (
    await taxDifferenceApi.taxDifferenceList(
      groupId,
      month,
      undefined,
      undefined,
      undefined,
      year,
      {
        headers: { Authorization: "Bearer " + Token }
      }
    )
  ).data;
  return response;
}
